module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0151.jpg?v=9f9db820";